import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { CreateGeofenceRequest } from 'src/app/models/geofence';

@Component({
  selector: 'app-geofence-form-dialog',
  templateUrl: './geofence-form-dialog.component.html',
  styleUrls: ['./geofence-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule],
})
export class GeofenceFormDialogComponent {
  geofenceForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<GeofenceFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { wkt: string }
  ) {
    this.geofenceForm = this.fb.group({
      name: ['', [Validators.required]],
      description: [''],
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.geofenceForm.valid) {
      const formValue = this.geofenceForm.value;
      const geofenceData: CreateGeofenceRequest = {
        name: formValue.name,
        description: formValue.description,
        border: this.data.wkt,
      };
      this.dialogRef.close(geofenceData);
    }
  }
}
